import { extend, localize} from "vee-validate";
import { required, min, digits, email } from "vee-validate/dist/rules";
import en from 'vee-validate/dist/locale/en.json';

extend('required', required);
extend('min', min);
extend('digits', digits);
extend('email', email);
extend('phone', phone => {
    const reg = /^078|073\d{7}$/g
    if (reg.test(phone) === false) return "The phone number should be either be an MTN or airtel number."
    return true
});
extend('age', age => {
  if (age < 18) return "The age limit should be 18 years"
  return true
})

localize('en', en);
